import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { createFormActiveStepAtom } from "Market/Atom/createFormAtoms";
import { FormWizardAnimation } from "Market/Components/Animation/FormWizardAnimation";
import { GeneralFormWidget } from "Market/Widgets/GeneralFormWidget";
import { RegionWizardCreateWidget } from "Market/Widgets/RegionWizardCreateWidget";
import { BlankCard } from "Shared/Components/Cards/BlankCard";
import { Map as MapIcon, Storefront } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";
import { useAtom } from "jotai";
import { useEffect } from "react";
import {
	FormStepper,
	type StepItem,
} from "../../Shared/Components/Form/FormStepper";

const marketResource = Resources.base.market.forms;

// Icons can be passed directly now that FormStepper StepItem accepts React.ElementType

export const marketCreateFormSteps: StepItem[] = [
	{
		key: 1,
		label: marketResource.steps.general,
		form: GeneralFormWidget,
		icon: Storefront,
	},
	{
		key: 2,
		label: marketResource.steps.regions,
		form: RegionWizardCreateWidget,
		icon: MapIcon,
	},
];

export function MarketCreatePage() {
	const { t } = useResource();
	const [activeStep, setActiveStep] = useAtom(createFormActiveStepAtom);

	const currentStep = marketCreateFormSteps.find(
		(step) => step.key === activeStep,
	);

	useEffect(() => {
		setActiveStep(1);
	}, []);

	const isLastStep = activeStep === marketCreateFormSteps.length;

	return (
		<Stack spacing={3} alignItems="center" width="100%">
			<Typography variant="h1">{t(marketResource.createMarket)}</Typography>
			<BlankCard>
				<Stack gap={10} padding={3}>
					<Box
						sx={{
							alignSelf: "center",
							width: {
								xs: "100%",
								md: "50%",
							},
						}}
					>
						<FormStepper
							activeStep={activeStep}
							steps={marketCreateFormSteps}
						/>
					</Box>

					{currentStep?.form && (
						<FormWizardAnimation
							keyProp={activeStep}
							disableExitAnimation={isLastStep}
						>
							<currentStep.form />
						</FormWizardAnimation>
					)}
				</Stack>
			</BlankCard>
		</Stack>
	);
}
